import { LocaleIdentifier } from '@repo/markets/types'
import { baseUrl } from './base'
import { createHrefForDocument } from './href'

export const createUrl = (path: string): Readonly<string> => {
  return `${baseUrl}${path}`
}

export const createProductUrl = (urlSlug: string, locale: LocaleIdentifier) => {
  return createUrl(createHrefForDocument('product', urlSlug, locale))
}
